import PropTypes from 'prop-types'

import { TitleItem, TitleGroup } from '../styles'

const RangeSlider = ({ items }) => {
  const renderTitleItems = (item) => {
    if (item % 2 === 0) {
      return (
        <TitleItem key={`range-${item}`}>
          {item}
        </TitleItem>
      )
    }
  }

  return (
    <TitleGroup>
      {items.map(renderTitleItems)}
    </TitleGroup>
  )
}

RangeSlider.propTypes = {
  items: PropTypes.array.isRequired
}

export default RangeSlider
